var _g, _defs, _g2, _clipPath, _use, _g3, _g4, _clipPath2, _use2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    xmlns: "http://www.w3.org/2000/svg",
    height: 29,
    id: "screenshot-9f92727f-8793-80c6-8007-455669133964",
    viewBox: "0 -1 29 29",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133964"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133964"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 27,
    height: 28,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-45566913396d"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-9f92727f-8793-80c6-8007-45566913396d-render-2",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: -1,
    width: 29,
    height: 29,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-9f92727f-8793-80c6-8007-45566913396d-render-2)",
    fill: "none"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-45566913396d"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: -1,
    width: 29,
    height: 29,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-45566913396e",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-45566913396e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.100358422938825,
    height: 28,
    x: 0.22547712387768115,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: -0.7551857004309568
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    id: "strokes-31cc07d5-2993-80ac-8007-461efc15367e-9f92727f-8793-80c6-8007-45566913396e",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape",
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-3-9f92727f-8793-80c6-8007-45566913396e-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3-9f92727f-8793-80c6-8007-45566913396e-0"
  }))), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0.22547712387768115,
    y: -0.7551857004309568,
    width: 28.100358422938825,
    height: 28,
    id: "stroke-shape-render-3-9f92727f-8793-80c6-8007-45566913396e-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(229, 126, 63)",
      strokeOpacity: 1
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3-9f92727f-8793-80c6-8007-45566913396e-0",
    clipPath: "url('#inner-stroke-render-3-9f92727f-8793-80c6-8007-45566913396e-0')"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-45566913396f"
  }, /*#__PURE__*/React.createElement("style", null, "#shape-{ .st0{fill:#4487C7;}\r\n\t.st1{fill:none;stroke:#4487C7;stroke-miterlimit:10;} }"))), /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133970"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133970"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.275634765625,5.86865234375C13.2720947265625,5.86865234375,12.368896484375,6.27001953125,11.666259765625,6.972412109375C10.9638671875,7.675048828125,10.5623779296875,8.578125,10.5623779296875,9.4814453125C10.5623779296875,11.488525390625,12.2685546875,13.09423828125,14.275634765625,13.09423828125L14.275634765625,13.09423828125C15.279296875,13.09423828125,16.1824951171875,12.69287109375,16.885009765625,11.990234375C17.58740234375,11.287841796875,17.989013671875,10.384765625,17.989013671875,9.4814453125C18.0892333984375,7.47412109375,16.3831787109375,5.86865234375,14.275634765625,5.86865234375Z",
    className: "st0",
    style: {
      fill: "rgb(154, 154, 154)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-31cc07d5-2993-80ac-8007-461efc16b024-9f92727f-8793-80c6-8007-455669133970"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.275634765625,5.86865234375C13.2720947265625,5.86865234375,12.368896484375,6.27001953125,11.666259765625,6.972412109375C10.9638671875,7.675048828125,10.5623779296875,8.578125,10.5623779296875,9.4814453125C10.5623779296875,11.488525390625,12.2685546875,13.09423828125,14.275634765625,13.09423828125L14.275634765625,13.09423828125C15.279296875,13.09423828125,16.1824951171875,12.69287109375,16.885009765625,11.990234375C17.58740234375,11.287841796875,17.989013671875,10.384765625,17.989013671875,9.4814453125C18.0892333984375,7.47412109375,16.3831787109375,5.86865234375,14.275634765625,5.86865234375Z",
    style: {
      fill: "none",
      strokeWidth: 0,
      stroke: "rgb(27, 142, 238)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133971"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133971"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.189697265625,13.19482421875C17.989013671875,12.993896484375,17.58740234375,12.993896484375,17.286376953125,13.19482421875C17.286376953125,13.19482421875,14.275634765625,15.5029296875,11.56591796875,13.19482421875C11.264892578125,12.993896484375,10.9638671875,12.993896484375,10.6627197265625,13.19482421875C10.5623779296875,13.294921875,7.953125,15.70361328125,7.852783203125,20.42041015625C7.852783203125,20.62109375,7.953125,20.82177734375,8.053466796875,20.92236328125C8.15380859375,21.0224609375,8.3544921875,21.123046875,8.55517578125,21.123046875L19.99609375,21.123046875C20.3974609375,21.123046875,20.6986083984375,20.82177734375,20.6986083984375,20.42041015625C20.6986083984375,20.2197265625,20.7989501953125,15.803955078125,18.189697265625,13.19482421875Z",
    className: "st0",
    style: {
      fill: "rgb(154, 154, 154)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-31cc07d5-2993-80ac-8007-461efc172d25-9f92727f-8793-80c6-8007-455669133971"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.189697265625,13.19482421875C17.989013671875,12.993896484375,17.58740234375,12.993896484375,17.286376953125,13.19482421875C17.286376953125,13.19482421875,14.275634765625,15.5029296875,11.56591796875,13.19482421875C11.264892578125,12.993896484375,10.9638671875,12.993896484375,10.6627197265625,13.19482421875C10.5623779296875,13.294921875,7.953125,15.70361328125,7.852783203125,20.42041015625C7.852783203125,20.62109375,7.953125,20.82177734375,8.053466796875,20.92236328125C8.15380859375,21.0224609375,8.3544921875,21.123046875,8.55517578125,21.123046875L19.99609375,21.123046875C20.3974609375,21.123046875,20.6986083984375,20.82177734375,20.6986083984375,20.42041015625C20.6986083984375,20.2197265625,20.7989501953125,15.803955078125,18.189697265625,13.19482421875Z",
    style: {
      fill: "none",
      strokeWidth: 0,
      stroke: "rgb(229, 126, 63)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133972"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133972"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.275656335347094,
    cy: 13.495710356916788,
    rx: 12.845878136200781,
    ry: 12.845878136200554,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-31cc07d5-2993-80ac-8007-461efc17954f-9f92727f-8793-80c6-8007-455669133972"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape",
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-7-9f92727f-8793-80c6-8007-455669133972-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-7-9f92727f-8793-80c6-8007-455669133972-0"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.275656335347094,
    cy: 13.495710356916788,
    rx: 12.845878136200781,
    ry: 12.845878136200554,
    id: "stroke-shape-render-7-9f92727f-8793-80c6-8007-455669133972-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(154, 154, 154)",
      strokeOpacity: 1
    }
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-7-9f92727f-8793-80c6-8007-455669133972-0",
    clipPath: "url('#inner-stroke-render-7-9f92727f-8793-80c6-8007-455669133972-0')"
  }))))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.a6e451738e013b4e091c9b619349e61c.svg";
export { ForwardRef as ReactComponent };